import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type VoidInvoiceMutationVariables = Types.Exact<{
  input: Types.VoidInvoiceInput;
}>;


export type VoidInvoiceMutation = { __typename?: 'Mutation', voidInvoice: { __typename?: 'InvoicePayload', invoice?: { __typename?: 'InvoiceStateData', invoiceId: string, status: Types.InvoiceStatus, voidReason?: string | null, voidedAt?: Types.TDateISO | null, voidedBy?: string | null, stripeTaxReversalTransactionId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RecordInvoicePaymentMutationVariables = Types.Exact<{
  input: Types.RecordInvoicePaymentInput;
}>;


export type RecordInvoicePaymentMutation = { __typename?: 'Mutation', recordInvoicePayment: { __typename?: 'RecordInvoicePaymentPayload', invoices?: Array<{ __typename?: 'InvoiceStateData', invoiceId: string, balance: number, status: Types.InvoiceStatus, payments: Array<{ __typename?: 'InvoicePaymentData', paymentId?: string | null }> }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AdjustInvoiceMutationVariables = Types.Exact<{
  input: Types.AdjustInvoiceInput;
}>;


export type AdjustInvoiceMutation = { __typename?: 'Mutation', adjustInvoice: { __typename?: 'InvoicePayload', invoice?: { __typename?: 'InvoiceStateData', invoiceId: string, amountAdjusted: number, balance: number, status: Types.InvoiceStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type WaiveInvoiceLateChargeMutationVariables = Types.Exact<{
  input: Types.WaiveInvoiceLateChargeInput;
}>;


export type WaiveInvoiceLateChargeMutation = { __typename?: 'Mutation', waiveInvoiceLateCharge: { __typename?: 'InvoicePayload', invoice?: { __typename?: 'InvoiceStateData', invoiceId: string, lateChargeWaived: number, balance: number, status: Types.InvoiceStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RetryInvoiceExportMutationVariables = Types.Exact<{
  input: Types.RetryInvoiceExportInput;
}>;


export type RetryInvoiceExportMutation = { __typename?: 'Mutation', retryInvoiceExport: { __typename?: 'RetryInvoiceExportPayload', success: boolean, export?: { __typename?: 'QuickBooksExportState', status: Types.QuickBooksExportStatus, remoteInvoiceId?: string | null, errorMessage?: string | null, lastAttemptAt?: Types.TDateISO | null, retryCount: number, resolvedRevenueRung?: Types.MergeDevRevenueRung | null, resolvedRevenueAccount?: { __typename?: 'MergeDevAccountDocument', accountNumber: string, name: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RetryPaymentExportMutationVariables = Types.Exact<{
  input: Types.RetryPaymentExportInput;
}>;


export type RetryPaymentExportMutation = { __typename?: 'Mutation', retryPaymentExport: { __typename?: 'RetryPaymentExportPayload', success: boolean, syncStatus?: Types.PaymentSyncStatus | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type EnsureInvoicePayLinkMutationVariables = Types.Exact<{
  input: Types.EnsureInvoicePayLinkInput;
}>;


export type EnsureInvoicePayLinkMutation = { __typename?: 'Mutation', ensureInvoicePayLink: { __typename?: 'InvoicePayLinkPayload', newLinkMade: boolean, payLink?: { __typename?: 'InvoicePayLinkData', payUrl?: string | null, expiresOn: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ResendInvoiceEmailMutationVariables = Types.Exact<{
  input: Types.ResendInvoiceEmailInput;
}>;


export type ResendInvoiceEmailMutation = { __typename?: 'Mutation', resendInvoiceEmail: { __typename?: 'ResendInvoiceEmailPayload', result?: { __typename?: 'InvoiceEmailResendResult', status: Types.InvoiceEmailResendStatus, reasonCode?: Types.InvoiceEmailResendSuppression | null, reason?: string | null, linkExpiresOn?: string | null, newLinkMade: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const VoidInvoiceDocument = new TypedDocumentString(`
    mutation VoidInvoice($input: VoidInvoiceInput!) {
  voidInvoice(input: $input) {
    invoice {
      ...VoidedInvoiceState
    }
    errors {
      code
      message
    }
  }
}
    fragment VoidedInvoiceState on InvoiceStateData {
  invoiceId
  status
  voidReason
  voidedAt
  voidedBy
  stripeTaxReversalTransactionId
}`);
export const RecordInvoicePaymentDocument = new TypedDocumentString(`
    mutation RecordInvoicePayment($input: RecordInvoicePaymentInput!) {
  recordInvoicePayment(input: $input) {
    invoices {
      ...SettledInvoiceState
    }
    errors {
      code
      message
    }
  }
}
    fragment SettledInvoiceState on InvoiceStateData {
  invoiceId
  balance
  status
  payments {
    paymentId
  }
}`);
export const AdjustInvoiceDocument = new TypedDocumentString(`
    mutation AdjustInvoice($input: AdjustInvoiceInput!) {
  adjustInvoice(input: $input) {
    invoice {
      ...AdjustedInvoiceState
    }
    errors {
      code
      message
    }
  }
}
    fragment AdjustedInvoiceState on InvoiceStateData {
  invoiceId
  amountAdjusted
  balance
  status
}`);
export const WaiveInvoiceLateChargeDocument = new TypedDocumentString(`
    mutation WaiveInvoiceLateCharge($input: WaiveInvoiceLateChargeInput!) {
  waiveInvoiceLateCharge(input: $input) {
    invoice {
      ...LateChargeWaivedInvoiceState
    }
    errors {
      code
      message
    }
  }
}
    fragment LateChargeWaivedInvoiceState on InvoiceStateData {
  invoiceId
  lateChargeWaived
  balance
  status
}`);
export const RetryInvoiceExportDocument = new TypedDocumentString(`
    mutation RetryInvoiceExport($input: RetryInvoiceExportInput!) {
  retryInvoiceExport(input: $input) {
    success
    export {
      ...QuickBooksExportStateRow
    }
    errors {
      code
      message
    }
  }
}
    fragment QuickBooksExportStateRow on QuickBooksExportState {
  status
  remoteInvoiceId
  errorMessage
  lastAttemptAt
  retryCount
  resolvedRevenueRung
  resolvedRevenueAccount {
    accountNumber
    name
  }
}`);
export const RetryPaymentExportDocument = new TypedDocumentString(`
    mutation RetryPaymentExport($input: RetryPaymentExportInput!) {
  retryPaymentExport(input: $input) {
    success
    syncStatus
    errors {
      code
      message
    }
  }
}
    `);
export const EnsureInvoicePayLinkDocument = new TypedDocumentString(`
    mutation EnsureInvoicePayLink($input: EnsureInvoicePayLinkInput!) {
  ensureInvoicePayLink(input: $input) {
    payLink {
      payUrl
      expiresOn
    }
    newLinkMade
    errors {
      code
      message
    }
  }
}
    `);
export const ResendInvoiceEmailDocument = new TypedDocumentString(`
    mutation ResendInvoiceEmail($input: ResendInvoiceEmailInput!) {
  resendInvoiceEmail(input: $input) {
    result {
      status
      reasonCode
      reason
      linkExpiresOn
      newLinkMade
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    VoidInvoice: build.mutation<VoidInvoiceMutation, VoidInvoiceMutationVariables>({
      query: (variables) => ({ document: VoidInvoiceDocument, variables })
    }),
    RecordInvoicePayment: build.mutation<RecordInvoicePaymentMutation, RecordInvoicePaymentMutationVariables>({
      query: (variables) => ({ document: RecordInvoicePaymentDocument, variables })
    }),
    AdjustInvoice: build.mutation<AdjustInvoiceMutation, AdjustInvoiceMutationVariables>({
      query: (variables) => ({ document: AdjustInvoiceDocument, variables })
    }),
    WaiveInvoiceLateCharge: build.mutation<WaiveInvoiceLateChargeMutation, WaiveInvoiceLateChargeMutationVariables>({
      query: (variables) => ({ document: WaiveInvoiceLateChargeDocument, variables })
    }),
    RetryInvoiceExport: build.mutation<RetryInvoiceExportMutation, RetryInvoiceExportMutationVariables>({
      query: (variables) => ({ document: RetryInvoiceExportDocument, variables })
    }),
    RetryPaymentExport: build.mutation<RetryPaymentExportMutation, RetryPaymentExportMutationVariables>({
      query: (variables) => ({ document: RetryPaymentExportDocument, variables })
    }),
    EnsureInvoicePayLink: build.mutation<EnsureInvoicePayLinkMutation, EnsureInvoicePayLinkMutationVariables>({
      query: (variables) => ({ document: EnsureInvoicePayLinkDocument, variables })
    }),
    ResendInvoiceEmail: build.mutation<ResendInvoiceEmailMutation, ResendInvoiceEmailMutationVariables>({
      query: (variables) => ({ document: ResendInvoiceEmailDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useVoidInvoiceMutation, useRecordInvoicePaymentMutation, useAdjustInvoiceMutation, useWaiveInvoiceLateChargeMutation, useRetryInvoiceExportMutation, useRetryPaymentExportMutation, useEnsureInvoicePayLinkMutation, useResendInvoiceEmailMutation } = injectedRtkApi;
